export default {"src":"/_next/static/media/arrow-left.99d10cab.svg","height":16,"width":17};